import { v4 as uuidv4 } from "uuid"
/*
motinersSignal:{
						success:0,
						req_id : reqId,
						type: 'res',
						receiver: 'web',
						error:{
							error_code_num:errCodeNum,
							res_data:{
								err_code:errCode,
								detail_code: detailCode,
								data:data
							}
						}
					}
*/
export const sendWebViewMsg = async ({ data = null, action, timeout = false, timeoutSec = 3000 }) =>
	new Promise((resolve, reject) => {
		try {
			if (!window.ReactNativeWebView) {
				reject({ error: "UNABLE_TO_PROCESS", detail_error: "APP_NOT_DETECTED" })
				return
			}

			//['error']['res_data']
			const reqId = uuidv4()
			let timer = null
			if (timeout === true) {
				const TIMEOUT = timeoutSec // 3 * 1000 = 3s
				timer = setTimeout(() => {
					/** android */
					document.removeEventListener("message", listener)
					/** ios */
					window.removeEventListener("message", listener)
					console.log("timeout triggered")
					reject({
						success: 0,
						error: {
							error_code_num: 500,
							res_data: {
								err_code: "REQ_TIMEOUT",
								detail_code: "BRIDGE_MESSAGE_TIMEOUT",
							},
						},
					})
				}, TIMEOUT)
			}
			const listener = (event) => {
				const res = JSON.parse(event.data)
				if (res?.motinersSignal) {
					const { data: response, req_id: listenerReqId, error } = res?.motinersSignal

					if (listenerReqId === reqId) {
						if (timeout === true) {
							clearTimeout(timer)
						}
						/** android */
						document.removeEventListener("message", listener)
						/** ios */
						window.removeEventListener("message", listener)
						if (typeof error === "object") {
							reject({ success: 0, error: error })
						} else {
							resolve({ success: 1, data: response })
						}
					}
				}
			}
			window.ReactNativeWebView.postMessage(
				JSON.stringify({
					motinersSignal: {
						req_id: reqId,
						type: "req",
						receiver: "app",
						action: action,
						data: data,
					},
				})
			)
			/** android */
			document.addEventListener("message", listener)
			/** ios */
			window.addEventListener("message", listener)
		} catch (err) {
			console.log(err)
			console.log("sendWebViewMsg err")
			reject(err)
		}
	})
